import React, { Component, createRef, useState, useEffect } from "react";
import { Row, Col, Card, Button, Space, Typography, Table, Input, Modal, Tag, Tooltip, Checkbox } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash, faSearch } from "@fortawesome/free-solid-svg-icons";
import _ from "lodash";

const NEW_JOB_STATUS_BASE_STATE = { name: "" };

function JobStatuses(props) {
  const [jobStatuses, setJobStatuses] = useState([]);
  const [filteredJobStatuses, setFilteredJobStatuses] = useState([]);
  const [searchTerm, setSearchTerm] = useState(null);

  const [selectedJobStatus, setSelectedJobStatus] = useState(null);
  const [editModalOpen, setEditModalOpen] = useState(false);

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const [addModalOpen, setAddModalOpen] = useState(false);
  const [newJobStatus, setNewJobStatus] = useState(NEW_JOB_STATUS_BASE_STATE);

  const table_columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text) => <Typography.Title level={5}>{text}</Typography.Title>,
      sorter: (a, b) => (a.name > b.name ? 1 : -1),
      defaultSortOrder: "ascend",
    },
    {
      title: "",
      dataIndex: "start",
      key: "start",
      render: (text, object) => (
        <>
          {object.start ? (
            <Tooltip title="This is the default status that new jobs will be created with">
              <Tag>Starting Status</Tag>
            </Tooltip>
          ) : null}{" "}
          {object.end ? (
            <Tooltip title="This is the status that marks a job as being finished">
              <Tag>Complete Status</Tag>
            </Tooltip>
          ) : null}
        </>
      ),
    },
    {
      title: "Actions",
      align: "right",
      dataIndex: "id",
      key: "id",
      render: (text, row) => (
        <Space>
          <Button
            size="small"
            type="primary"
            onClick={() => {
              setEditModalOpen(true);
              setSelectedJobStatus(jobStatuses.find((f) => f.id === text));
            }}
          >
            <FontAwesomeIcon icon={faEdit} className="mr-1" />
            Edit
          </Button>
          <Button
            size="small"
            danger
            onClick={() => {
              setDeleteModalOpen(true);
              setSelectedJobStatus(jobStatuses.find((f) => f.id === text));
            }}
          >
            <FontAwesomeIcon icon={faTrash} className="mr-1" />
            Delete
          </Button>
        </Space>
      ),
    },
  ];

  const GetJobStatuses = async () => {
    let response = await props.AxiosRequest("/api/job-statuses/get");
    setJobStatuses(response.data.job_statuses);
    setFilteredJobStatuses(response.data.job_statuses);
  };
  const UpdateJobStatus = async () => {
    await props.AxiosRequest("/api/job-statuses/update", { id: selectedJobStatus.id, name: selectedJobStatus.name, start: selectedJobStatus.start ? 1 : 0, end: selectedJobStatus.end ? 1 : 0 });
    GetJobStatuses();
    setEditModalOpen(false);
    setSelectedJobStatus(null);
  };
  const DeleteJobStatus = async () => {
    await props.AxiosRequest("/api/job-statuses/delete", { id: selectedJobStatus.id });
    GetJobStatuses();
    setDeleteModalOpen(false);
    setSelectedJobStatus(null);
  };
  const AddJobStatus = async () => {
    if (newJobStatus.name.length === 0) return props.MakeNotification("info", "Please Enter All Required Fields.");
    await props.AxiosRequest("/api/job-statuses/insert", { ...newJobStatus, start: newJobStatus.start ? 1 : 0, end: newJobStatus.end ? 1 : 0 });
    GetJobStatuses();
    setAddModalOpen(false);
    setNewJobStatus(NEW_JOB_STATUS_BASE_STATE);
  };

  useEffect(() => {
    GetJobStatuses();
  }, []);

  useEffect(() => {
    if (searchTerm?.length === 0) return setFilteredJobStatuses(jobStatuses);
    let filtered_list = jobStatuses.filter((f) => (_.toLower(f.name).indexOf(_.toLower(searchTerm)) > -1 ? true : false));
    setFilteredJobStatuses(filtered_list);
  }, [searchTerm]);

  return (
    <main className="content">
      <div className="container-fluid">
        <div className="header">
          <h1 className="header-title">Job Statuses</h1>
        </div>
        <Row>
          <Card
            title={<>Job Statuses</>}
            style={{
              width: "100%",
            }}
            extra={
              <>
                <Button
                  type="primary"
                  onClick={() => {
                    setNewJobStatus(NEW_JOB_STATUS_BASE_STATE);
                    setAddModalOpen(true);
                  }}
                >
                  <FontAwesomeIcon icon="plus" className="me-2" />
                  Add A New Job Status
                </Button>
              </>
            }
          >
            <Row>
              <Col span={18}></Col>
              <Col span={6}>
                <Input
                  className="mb-2"
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                  }}
                  placeholder="Search..."
                  allowClear
                />
              </Col>
            </Row>
            <Table className="table table-striped hover" columns={table_columns} dataSource={filteredJobStatuses} />
          </Card>
        </Row>
        <Modal
          title={"Edit Job Status"}
          centered
          open={editModalOpen}
          onCancel={() => {
            setEditModalOpen(false);
            setSelectedJobStatus(null);
          }}
          footer={
            <>
              <Button
                onClick={() => {
                  setEditModalOpen(false);
                  setSelectedJobStatus(null);
                }}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  UpdateJobStatus();
                }}
              >
                Save Changes
              </Button>
            </>
          }
        >
          {selectedJobStatus ? (
            <>
              <Row>
                <Col span={24}>
                  <label className="col-form-label-sm">Job Status Name *</label>
                  <Input
                    value={selectedJobStatus.name}
                    onChange={(e) => {
                      setSelectedJobStatus({ ...selectedJobStatus, name: e.target.value });
                    }}
                  />
                </Col>
                <Col span={24}>
                  <label className="col-form-label-sm">Status Settings</label>
                </Col>
                <Col span={12}>
                  <Checkbox
                    checked={selectedJobStatus.start}
                    onChange={(e) => {
                      setSelectedJobStatus({ ...selectedJobStatus, start: e.target.checked });
                    }}
                  >
                    <Tooltip title="This is the default status that new jobs will be created with">Starting Status</Tooltip>
                  </Checkbox>
                </Col>
                <Col span={12}>
                  <Checkbox
                    checked={selectedJobStatus.end}
                    onChange={(e) => {
                      setSelectedJobStatus({ ...selectedJobStatus, end: e.target.checked });
                    }}
                  >
                    <Tooltip title="This is the status that marks a job as being finished">Complete Status</Tooltip>
                  </Checkbox>
                </Col>
              </Row>
            </>
          ) : null}
        </Modal>

        <Modal
          title={"Are you sure?"}
          centered
          open={deleteModalOpen}
          onCancel={() => {
            setDeleteModalOpen(false);
            setSelectedJobStatus(null);
          }}
          footer={
            <>
              <Button
                onClick={() => {
                  setDeleteModalOpen(false);
                  setSelectedJobStatus(null);
                }}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                danger
                onClick={() => {
                  DeleteJobStatus();
                }}
              >
                Delete
              </Button>
            </>
          }
        >
          {selectedJobStatus ? <>Are you sure you want to delete the job status {selectedJobStatus?.name}?</> : null}
        </Modal>

        <Modal
          title={"Add A New Job Status"}
          centered
          open={addModalOpen}
          onCancel={() => {
            setAddModalOpen(false);
            setSelectedJobStatus(null);
          }}
          footer={
            <>
              <Button
                onClick={() => {
                  setAddModalOpen(false);
                  setSelectedJobStatus(null);
                }}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  AddJobStatus();
                }}
              >
                Add
              </Button>
            </>
          }
        >
          {newJobStatus ? (
            <>
              <Row>
                <Col span={24}>
                  <label className="col-form-label-sm">Job Status Name *</label>
                  <Input
                    value={newJobStatus.name}
                    onChange={(e) => {
                      setNewJobStatus({ ...newJobStatus, name: e.target.value });
                    }}
                  />
                </Col>
                <Col span={24}>
                  <label className="col-form-label-sm">Status Settings</label>
                </Col>
                <Col span={12}>
                  <Checkbox
                    checked={newJobStatus.start}
                    onChange={(e) => {
                      setNewJobStatus({ ...newJobStatus, start: e.target.checked });
                    }}
                  >
                    <Tooltip title="This is the default status that new jobs will be created with">Starting Status</Tooltip>
                  </Checkbox>
                </Col>
                <Col span={12}>
                  <Checkbox
                    checked={newJobStatus.end}
                    onChange={(e) => {
                      setNewJobStatus({ ...newJobStatus, end: e.target.checked });
                    }}
                  >
                    <Tooltip title="This is the status that marks a job as being finished">Complete Status</Tooltip>
                  </Checkbox>
                </Col>
              </Row>
            </>
          ) : null}
        </Modal>
      </div>
    </main>
  );
}

export default JobStatuses;
